import { AccountMagicLink } from './account-magic-link';
import { SubscriptionData } from './subscription-data';

export interface AccountData {
    accountId: string;
    accountName: string;
    accountOwner: string;
    accountTier: string;
    cohort: string;
    sfId: string;
    idp: string;
    status: boolean;
    domains: string[];
    subscriptions: SubscriptionData[];
    magicLinks: AccountMagicLink[];
    notes: string;
    ceManager: string;
    accountDirector: string;
    contentAnalyst: string;
    analystHours: number;
    briefings: number;
    videos: number;
    newsletters: number;
    clientUrl: string;
    clientHeadquarters: string;
    budgetHolder: string;
    influencer: string;
    techPerson: string;
    revenue: number;
}

type Partial<T> = { [p in keyof T]?: T[p]; };

export type PartialAccountData = Partial<AccountData>;
